import { Header, Menu } from '@/components';
import ResizableBoxWithHandle from '@/components/common/resizable-box-with-handle';
import MenuMobile from '@/components/layout/menu/menu.mobile';
import { useSessionTimer, UseSessionTimerReturn, useToggle } from '@/hooks';
import { isTablet } from '@/utils';
import { isMobile } from '@/utils/mobile.util';
import { createContext, memo, useContext } from 'react';
import { Outlet } from 'react-router-dom';

type IProps = {};

export type TMenuContext = {
	menuOpen: boolean;
	onToggle: () => void;
	setMenuOpen: (value: boolean) => void;
};

export const MenuContext = createContext<TMenuContext>({} as TMenuContext);

export const SessionTimerContext = createContext<UseSessionTimerReturn | null>(
	null
);

export const useSessionTimerContext = (): UseSessionTimerReturn => {
	const ctx = useContext(SessionTimerContext);
	if (ctx == null) {
		throw new Error(
			'useSessionTimerContext must be used within SessionTimerProvider'
		);
	}
	return ctx;
};

export const SessionTimerProvider = ({
	children,
}: {
	children: React.ReactNode;
}) => {
	const value = useSessionTimer();
	return (
		<SessionTimerContext.Provider value={value}>
			{children}
		</SessionTimerContext.Provider>
	);
};

const MainLayoutComponent = (props: IProps) => {
	const [menuOpen, onToggle, setMenuOpen] = useToggle(isMobile ? false : true);
	return (
		<div className="h-screen bg-white lg:bg-blue2">
			<MenuContext.Provider value={{ menuOpen, onToggle, setMenuOpen }}>
				<SessionTimerProvider>
					<Header />
					<div className="block lg:flex">
						{isMobile ? (
							<MenuMobile />
						) : (
							<ResizableBoxWithHandle width={!isTablet ? 220 : 180}>
								<Menu />
							</ResizableBoxWithHandle>
						)}
						<div
							className={`bg-blue5 h-screen xl:h-[calc(100vh_-_70px)] w-full xl:px-4 pb-20 2xl:pb-2.5 2xl:px-9 overflow-auto ${isMobile ? 'pb-[80px]' : ''}`}
						>
							<Outlet />
						</div>
					</div>
				</SessionTimerProvider>
			</MenuContext.Provider>
		</div>
	);
};

export const MainLayout = memo(MainLayoutComponent);
